module.exports = __webpack_public_path__ + "static/media/phone_broadband.4b075942.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/phone_broadband.svg
 ** module id = 1304
 ** module chunks = 0
 **/